import React from 'react';

interface DatePickerProps {
  name: string;
  value: string;
  onChangeHandler: (value: string) => void;
  id: string;
  style?: React.CSSProperties;
  defaultRange?: string;
  error?: {
    hasError: boolean;
    message: string;
  };
}

const useNewDateRangePicker =
  import.meta.env.VITE_ENABLE_NEW_DATERANGEPICKER === 'true';

const DatePickerLazy = React.lazy(() =>
  useNewDateRangePicker
    ? import('./DatePickerNew')
    : import('./DatePickerLegacy')
);

const DatePicker: React.FC<DatePickerProps> = (props) => (
  <React.Suspense fallback={<div style={{ height: 38 }} />}>
    <DatePickerLazy {...props} />
  </React.Suspense>
);

export default DatePicker;
